export default "__VITE_ASSET__xKc2Eu3K__"